import { Tooltip, TooltipProps } from "@chakra-ui/react";

export type Props = {
  /**
   * Whether to show the tooltip. When `false`, the children are rendered without a tooltip wrapper.
   */
  showTooltip: boolean;
} & TooltipProps;

/**
 * A wrapper component that conditionally renders a Chakra UI Tooltip around its children.
 * When `showTooltip` is `true`, the children are wrapped in a Tooltip component.
 * When `showTooltip` is `false`, the children are rendered directly without a tooltip.
 *
 * @example
 * ```tsx
 * <ConditionalTooltip
 *   showTooltip={isDisabled}
 *   label="This action is disabled"
 *   placement="top"
 *   hasArrow
 * >
 *   <Button isDisabled={isDisabled}>Action</Button>
 * </ConditionalTooltip>
 * ```
 */
export const ConditionalTooltip: React.FC<Props> = ({
  showTooltip,
  children,
  ...props
}) => {
  return showTooltip ? <Tooltip {...props}>{children}</Tooltip> : children;
};
